export const enum BuildYourTripModalType {
  DestinationSelector = 'destinationSelector',
  None = 'none',
}
